import React from "react";
import "./styles.css"
import {curatedLink} from "../Books/filters";

function AboutUs() {
    return (
        <div className="container about-container">
            <div className="text-center">
                <h6 className="about-text mx-auto mt-2">Этот сервис помогает не запутаться в книжных новинках и быстро
                    выбрать самые высокооцененные и популярные книги.</h6>
            </div>
            <div className="text-center">
                <h6 className="about-text mx-auto">Начните знакомство с
                    <a href={curatedLink({yearMin: 2023, yearMax: 2023, totalGradesMin: 15, orderBy: 'total_desc'})}> популярными
                        книгами с годом 2023 в каталоге</a>,
                    <a href={curatedLink({yearMin: 0, yearMax: 2022, totalGradesMin: 60, orderBy: 'average_desc'})}> книгами
                        с высокими оценками</a> и
                    <a href={curatedLink({yearMin: 1, yearMax: 2022, totalGradesMin: 400, orderBy: 'average_desc'})}> самыми
                        популярными книгами</a></h6>
            </div>
        </div>
    );
}

export default AboutUs;
